/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Cmp_Page_When_Title_V2Inputs */

const en_mk_cmp_page_when_title_v2 = /** @type {(inputs: Mk_Cmp_Page_When_Title_V2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`When ${i?.name} is the better choice`)
};

const id_mk_cmp_page_when_title_v2 = /** @type {(inputs: Mk_Cmp_Page_When_Title_V2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kapan ${i?.name} pilihan yang lebih tepat`)
};

/**
* | output |
* | --- |
* | "When {name} is the better choice" |
*
* @param {Mk_Cmp_Page_When_Title_V2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_when_title_v2 = /** @type {((inputs: Mk_Cmp_Page_When_Title_V2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_When_Title_V2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_when_title_v2(inputs)
	return en_mk_cmp_page_when_title_v2(inputs)
});